import * as React from 'react';
import {
  Wrapper,
  PaginationWrapper,
  ButtonWrapper,
  CipCounter
} from './styled';
import { Pagination } from '@app/src/components/Pagination';
import { Button } from '@app/src/components/Button';
import { Tooltip } from '@app/src/components/Tooltip';
import { ModalContainer } from '@app/src/utils/ModalLogout';

interface Props {
  url: string;
  items: Array<object>;
  filter: object;
  totalPages: number;
  page: number;
  totalRow: number;
  getPage: Function;
  isFetchingDetails: boolean;
  handleClickDownload: Function;
}

export const Container: React.FC<Props> = ({
  url,
  items,
  filter,
  totalPages,
  page,
  getPage,
  totalRow,
  isFetchingDetails,
  handleClickDownload
}) => {
  const [ showModal, setShowModal ] = React.useState(false);
  const isDisabledButton: boolean = items.length === 0;

  const handleClickDownloadExcel = (filter) => {
    const reportToken = sessionStorage.getItem('reportToken');
    if (!reportToken) {
      setShowModal(true);
    }
    handleClickDownload(filter)
  }

  return(
    <Wrapper>
      {page <= totalPages && (
        <>
          <ButtonWrapper>
            <CipCounter data-test="reportSpanSumary">{items.length} registros de {totalRow}</CipCounter>
            <Tooltip title="Descargar Excel">
              <Button
                data-test="reportButtonExcelBottom"
                icon="download-cloud"
                width="94px"
                onClick={() => handleClickDownloadExcel(filter)}
                disabled={isDisabledButton}
              />
            </Tooltip>
          </ButtonWrapper>
          <PaginationWrapper>
            <Pagination
              totalPages={totalPages}
              defaultPage={page}
              onClickFirstPage={(page) => getPage(page, filter, url)}
              onClickPrevPage={(page) => getPage(page, filter, url)}
              onClickNextPage={(page) => getPage(page, filter, url)}
              onClickLastPage={(page) => getPage(page, filter, url)}
              onClickCurrentPage={(page) => getPage(page, filter, url)}
              loading={isFetchingDetails}
            />
          </PaginationWrapper>
        </>
      )}
      {showModal &&
        <ModalContainer data-test="modal" message='Por favor, vuelva a iniciar sesión' />
      }
    </Wrapper>
  );
};
